export default __webpack_public_path__ + "static/box_w.ae5f4cbfcf2df85dbd6a56f3f80b8cbe.png";